ele.lawguide = {

    breadCrumbStart: "<a href='?event=home'>Home</a>",

	createBreadcrumbString: function(lawguides, subsites){

		// Loop through how many .collection elements there are, pick 1
		// find all link elements with the class 'open' and store their href and text into an array
		// find .lawguide and look for all open elements, store their href and text into an array
		// Use the arrays to write the breadcrumb string			
		
		var breadcrumbString = ele.lawguide.breadCrumbStart;

		if(subsites){
			let subsiteCrumbs = this.gatherBreadcrumbs('.collection', true);
			breadcrumbString = breadcrumbString + subsiteCrumbs;
		}
		if(lawguides){
			let lawguideCrumbs = this.gatherBreadcrumbs('.lawguide', false);
			breadcrumbString = breadcrumbString + lawguideCrumbs;
		}
	
		if(breadcrumbString != ele.lawguide.breadCrumbStart){
			$('#breadCrumbContainerDivInner').html(breadcrumbString);
		}	
	
	},

	gatherBreadcrumbs: function(element, linkToLeaf){
		
		var breadcrumbArray = [];
		var breadcrumbString = "";
		var exitLoop = 0;

		$(element).each(function(){
			if (exitLoop === 0){
				var openElements = $(this).find('a.open');
				openElements.each(function(index, value){
					breadcrumbArray[index] = [];
					breadcrumbArray[index][0] = $(this).text();
					if($(this).attr('href') != undefined){ 
						breadcrumbArray[index][1] = $(this).attr('href');
					} else {
						breadcrumbArray[index][1] = "";
					}	
					exitLoop++;
				});
			}	
		});

		$.each(breadcrumbArray, function(index, value){
			if(value[1] != "" && (linkToLeaf || index+1 < breadcrumbArray.length)){
				breadcrumbString = breadcrumbString + ' > <a href="' + value[1] + '">' + value[0] + '</a>';
			} else {
				breadcrumbString = breadcrumbString + ' > <span>' + value[0] + '</span>';
			}	
		});
		return breadcrumbString;
				
	},
	
	lawguideNavigation: function(lawguideIdentifier){

		// This looks after the show and hide functionality of the lawguide menu 
		$(".lawguide a.level2, .lawguide a.level4","#lawguide").bind("click",function(){
			$("#lawguide-"+this.id.split("-")[1]+"-children").toggle();
		});
		
		// this handles the lawguide nav level 3 dropdown
		$('.lawguide a.level3').each(function(){
			var submenu = $(this).siblings("ul").children("li");
			if (submenu.length > 1) {
				$(this).click(function() {
					$(this).toggleClass("open");
					$(this).parent('li').children('ul').slideToggle("fast");
				});
			} else {
				$(this).addClass("singlechild");	//add a special class for custom styling
				$(this).attr("href", submenu.children("a").attr("href")); //use link of only child
				if ($(this).hasClass("open")) {
					submenu.remove();
					$(this).addClass("selected");
				}
			}
		});
		
	},
	
	productNavigation: function(){
		
		//Services box Open/close functionality and highlight selected node
		if( $('.e_sidebar .e_services').length ) {
			$('.e_sidebar .e_services .e_head .e_right div').bind('mouseenter', function(){
				$(this).parents('.e_services')
				.addClass('e_on')
				.one('mouseleave', function(){
					$(this).removeClass('e_on');
				});
			});
			
			//this should be in view code but can't for the life of me find out where the menu is rendered
			$('.e_sidebar .e_services .collection ul').children('LI.open').addClass('selected');
		}
			
		// show.hide product descriptions
		$('.ele-product .e_productObjects .e_object .e_name').on('click', function() {
			const $eName = $(this);
        	const $eDesc = $eName.siblings('.e_desc');

			$(this).siblings('.e_desc').toggle();
			$eName.toggleClass('icon_minus', $eDesc.is(':visible')); // Add 'minus' class when .e_desc is visible
		});	
			
	},
	
	// This function can be overwritten locally to change the elements the breadcrumbs look at and which functions run.
	startLawguideJS: function(){
		
		this.lawguideNavigation();
		this.productNavigation();
		this.createBreadcrumbString(true,true);
		
	}
	
};

$(document).ready(function(){
	ele.lawguide.startLawguideJS();
});
